import ingealimentosApi, { getDomain } from '../../services/ingealimentosApi'

export const getServiceItems = params => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.get('/service_items', { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const getServiceItem = (id, params) => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.get(`/service_items/${id}`, { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const storeServiceItem = data => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.post('/service_items', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const updateServiceItem = (id, data) => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.put(`/service_items/${id}`, data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const deleteServiceItem = id => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.delete(`/service_items/${id}`)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const searchServiceItems = async (term, token) => (
	fetch( getDomain()+`/service_items?filter[name]=${term}`, {
		headers: {'Authorization': `Bearer ${token}`}
	})
		.then((response) => response.json())
		.then((res) =>
			res.data.map(item => ({
				label: item.name,
				value: item.id,
			})),
		)
)